var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.414,
    clipRule: "evenodd",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M64.444 30.001c24.374.19 49.922 9.735 62.228 30.594.585.992 1.323 2.479 1.323 2.479.739 1.976-1.234 4.17-2.723 6.404C112.337 88.877 87.645 98 63.765 98c-24.269 0-50.062-9.445-62.05-30.589C1.1 66.326.336 64.69.336 64.69c-.52-1.494.721-3.14 1.684-4.753 11.808-19.784 36.516-29.743 61.276-29.936h1.148Zm-1.127 4c-21.626.169-43.742 7.796-56.05 25.208-1.057 1.495-2.034 3.052-2.869 4.682 0 0 3.081 5.632 6.767 9.721 13.377 14.834 34.636 20.785 54.803 20.365 22.83-.475 46.856-9.45 57.836-29.797 0 0 .045-.454-.168-.839-10.846-19.342-35.36-29.154-59.213-29.34-.369-.001-.737-.001-1.106 0Zm1.028 15c9.905.188 17.976 11.856 13.325 21.502-4.061 8.424-16.853 11.041-23.866 4.353-8.237-7.855-3.561-25.595 10.154-25.855h.387Zm-.336 4c-7.254.137-13.177 8.704-9.773 15.764 2.981 6.185 12.358 8.102 17.502 3.196 3.46-3.298 4.392-8.958 2.086-13.2-1.921-3.536-5.498-5.788-9.815-5.76Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassShow);
export default __webpack_public_path__ + "static/media/passShow.0bcd836f3a878cf2c60bb2fcb17cc9f8.svg";
export { ForwardRef as ReactComponent };